/*
 * Text Input Component
 * */
import React, { useEffect, useState, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { randomIdentifier } from '../../../utils/helpers';

type Props = {
  id: String,
  name: String,
  value: String,
  style: any,
  path: String,
  checked: boolean,
  handleChange: Function,
  mutiple: Boolean,
  expired_at: Date,
  coupon_type: String,
  close: Boolean,
  handleRemoveCoupon: Function,
  coupon_id: Number,
  data: Object,
};

const CouponSelector = ({
  id,
  name,
  value,
  path,
  checked,
  handleChange,
  mutiple,
  close,
  handleRemoveCoupon,
  data,
}: Props) => {
  

  const [isChecked, setIsChecked] = useState(checked);
  useEffect(() => {
      if(isChecked != checked)
          setIsChecked(!isChecked);
  }, [checked])


  const _handleChange = (e) => {
    if (typeof handleChange == 'function') handleChange(e, data);
  };

  return (
    <label className="photo-selector">
      <input
        type={mutiple ? 'checkbox' : 'radio'}
        id={id}
        name={name}
        checked={isChecked}
        value={value}
      />
      <div className="photo-selector__thumb" onClick={_handleChange}>
        <img src={path} alt="" />
        {!close && (
          <div className="marker">
            <img src="/images/icon_checkmark_big.svg" alt="" />
          </div>
        )}

        <div className="coupon-card__content" >
          <img
            className="coupon-card__content__icon"
            src="/images/icon_coupon02.svg"
          />
          <div className="coupon-card__content__text">
            <label className="coupon-card-text-title">영상편지</label>
            <br />
            <label className="coupon-card-text-type">
              {data.admin_id ? '1회 무료 쿠폰 ' : '무료 1회권'}
            </label>
            <br />
            <label className="coupon-card-text-description">
              유효기간 : {data?.expired_at ?? '무제한' }
            </label>
          </div>
        </div>
        <div className="creator">
            <span>{data.admin_id ? '관리자 지급 ' : '사용자 구매'}</span>
          </div>
        {close && (
          <div className="close-coupon" onClick={handleRemoveCoupon}>
            <img src="/images/icon_close_bl.svg" />
          </div>
        )}
      </div>
    </label>
  );
};

CouponSelector.defaultProps = {
  id: 'js-' + randomIdentifier(),
  name: 'input-' + randomIdentifier(),
  value: '',
  style: false,
  path: '',
  checked: false,
  handleChange: () => {},
  mutiple: true,
};

export default memo(CouponSelector);
